import inicialState from './imuno.state';
import * as actions from './imuno.action';

const imunologiaReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.IMUNOLOGIA_FINALIZADA:
      return {
        ...state,
        imunologiaFinalizada: action.payload.imunologiaFinalizada,
      };
    default:
      return state;
  }
};

export default imunologiaReducer;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/imuno/imuno.reducer.js